import { fetchApi } from '@/config/axiosSetting';
import {
  GetAlertsParams,
  GetAlertsResponse,
} from '@/modules/adjusterReportModules/adjusterReport/queries/getAlerts/getAlertsQuery.type';

export const getAlertsQueryFunctions = (
  params: GetAlertsParams,
): Promise<GetAlertsResponse> =>
  fetchApi.get(`property/reports/${params.id}/alerts/`, {
    params: {
      user_type: params.user_type,
      damaged_pk: params.damaged_pk,
      source: params.source,
    },
  });
